import { getUrlHashParams } from './getUrlHashParams';

const getIFrameIdFromUrl = () => {
  const hashParams = getUrlHashParams();

  if (hashParams && hashParams.iFrameId) {
    return hashParams.iFrameId;
  }
};

export default getIFrameIdFromUrl;
